import styled from 'styled-components';
import {popUpBody} from '../../../newPopup/mobilePopup/MobilePopup.css';
import {container as innerPopContainer} from '../../../newPopup/innerPop/InnerPop.css';
import {mobileMedia} from '../../../../globalVariables/GlobalVariables';

export const container = styled.div`
    ${popUpBody}{
        background: transparent;
        box-shadow: none;
    }
    ${innerPopContainer}{
        ${mobileMedia}{
            width: 100%;
        }
    }
`;

